import module from 'module';
import _ from 'lodash';

const templateUrl = require('./customer-landing-page.template.html');
module.component('customerLandingPage', {
  templateUrl: templateUrl,
  controller: function () {

  }
});